import React from 'react';
import { CheckCircle, Upload } from 'lucide-react';
import { Button } from '../ui/button';

const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const VVFStatusSidebar = ({ caricato, dataCaricamento, onMarkUploaded }) => (
  <div className="bg-[#121212] border border-[#27272A] p-6">
    <h3 className="text-lg font-semibold uppercase mb-4" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
      Stato Portale VVF
    </h3>
    {caricato ? (
      <div className="text-center">
        <CheckCircle className="w-16 h-16 text-[#009246] mx-auto mb-4" />
        <p className="text-[#009246] font-semibold uppercase mb-2">Caricato</p>
        <p className="text-[#71717A] text-sm font-mono">{formatDate(dataCaricamento)}</p>
      </div>
    ) : (
      <div className="text-center">
        <Upload className="w-16 h-16 text-[#FFC107] mx-auto mb-4" />
        <p className="text-[#FFC107] font-semibold uppercase mb-4">Da caricare</p>
        <Button
          onClick={onMarkUploaded}
          className="w-full bg-[#009246] hover:bg-[#007a3a] text-white rounded-none uppercase tracking-wide"
          data-testid="mark-uploaded-btn"
        >
          <CheckCircle className="w-4 h-4 mr-2" />
          Segna come caricato
        </Button>
      </div>
    )}
  </div>
);
